<span
  class="iu-input-textarea-ui"
  tooltipPosition="top"
  tooltipZIndex="2100"
  [escape]="false"
  [hideDelay]="250"
  [iuValidationDisplay]="data?.hasValidation"
  [iuValidationDisplay.datacontainer]="this"
  [iuValidationDisplay.inputSelector]="'.ui-textarea.iu-field'"
  [iuValidationDisplay.valid]="isValid()"
  [life]="3000"
  pTooltip="{{ tooltip }}"
  [showDelay]="500">
  @if (this.isLabelDisplay) {
    <label
      iu-apiz-label
      [fontSize]="overridedCSS?.labelFontSize"
      [for]="uuid"
      [isFieldOnly]="data?.isFieldOnly"
      [label]="label"
      >{{ label }}</label
    >
  }
  <textarea
    #input
    autoResize="autoResize"
    autocomplete="off"
    data-cy="input-text"
    pInputTextarea
    [attr.data-cy-columnName]="data ? data.columnName : columnName"
    [attr.value]="fieldValue"
    [ngClass]="[
      hasConflict ? 'iu-input-text-conflict' : '',
      isReadOnly ? 'p-disabled' : '',
      cssClassMandatory || '',
      'ui-textarea iu-field',
      mandatoryCss || '',
    ]"
    [readonly]="isReadOnly ? 'disabled' : null"
    [rows]="shouldSyncHeightWithLine ? rows : 5"
    [style.font-size]="overridedCSS?.inputFontSize"
    [style.resize]="resize"
    [tabindex]="isReadOnly ? '-1' : null"
    [(ngModel)]="fieldValue"
    (change)="dataChange(input.value)"
    (contextmenu)="onContextMenu($event)"
    (press)="onContextMenu($any($event))"></textarea>

  @if (hasConflict && dataStored) {
    <span
      #spanInput
      class="p-autocomplete-conflict-star"
      role="button"
      tabindex="0"
      [attr.title]="opConflict.iconTooltip"
      [attr.aria-label]="opConflict.iconTooltip"
      (click)="opConflict.toggle($event)"
      (keydown.enter)="opConflict.toggle($event)"
      (keydown.space)="opConflict.toggle($event)">
      <i aria-hidden="true" class="fas fa-exclamation-triangle"></i>
    </span>
  }
  @if (showValuePrefPanel) {
    <iu-prime-overlay #opValuePref appendTo="body" [dismissable]="false">
      <iu-value-preference-panel
        [data]="this.data"
        [dataStored]="this.dataStored"
        [fieldValue]="fieldValue"
        [overlayPanel]="opValuePref"
        [sourceComponent]="this"
        (closeEmitter)="toggleValuePreferencePanel($event)" />
    </iu-prime-overlay>
  }
</span>

<iu-field-conflict-panel #opConflict [field]="this" />
